module.exports = __webpack_public_path__ + "static/competicao-4-b0e56e202035a66aa1c6cee7941913d4.jpeg";